import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { ServerResponse } from 'app/services/data/models/server-response';

@Injectable({
  providedIn: 'root',
})
export class NgSelectDynamicServiceService {
  constructor(public httpClient: HttpClient) {}

  getBasePath(): string {
    return environment.apiUrl;
  }

  public getValue(apiPath, methodPath, key): Observable<any> {
    const url = this.getBasePath() + apiPath + methodPath + key;
    return this.httpClient.get<any>(url);
  }

  public getValues(apiPath, methodPath, serverResponse, filter?): Observable<any[]> {
    const url = this.getBasePath() + apiPath + methodPath;
    let params = new HttpParams();
    if (filter) {
      filter && (params = params.append('filter', filter));
    }
    if (!serverResponse) {
      return this.httpClient.get<any>(url, { params });
    }
    return this.httpClient.get<ServerResponse<any>>(url, { params }).pipe(
      map((responseData) => {
        const items = responseData.values;
        return items;
      }),
    );
  }
}
